import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store' 
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios' 
import func from './plugins/func'
import VueAxios from 'vue-axios'
 import FlagIcon from 'vue-flag-icon'
import VueI18n from 'vue-i18n'
 import MultiFiltersPlugin from './plugins/MultiFilter'
import "toastr/build/toastr.css"
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import VEditor from 'yimo-vue-editor'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import 'sweetalert2/dist/sweetalert2.min.css'
  
//window.BACKEND_URL = 'http://vip_backend.dz:8866/api/'
window.BACKEND_URL = 'https://vipbackend.mesanalyses.dz/api/' 

//let URL_PUBLIC_FOLDER = 'http://vip_backend.dz:8866/website/'
let URL_PUBLIC_FOLDER = 'https://vipbackend.mesanalyses.dz/public/website/'
// window.BACKEND_URL = 'http://vipbackend.mesanalyses.dz/api/'

window.USER_BACKEND_URL = 'https://api.mesanalyses.dz/api/'
//window.USER_BACKEND_URL = 'http://mes_analyses.dz:8866/api/'

//window.USER_BACKEND_PROFIL = 'http://mes_analyses.dz:8866/'
window.USER_BACKEND_FOLDER = 'https://api.mesanalyses.dz/public/'
//window.USER_BACKEND_FOLDER = 'http://mes_analyses.dz:8866/public/'

Vue.use(VueSweetalert2); 
Vue.filter("URL",(data) => {
  return URL_PUBLIC_FOLDER + data
})
Vue.filter("URL0", (data) => {
  return USER_BACKEND_FOLDER + 'imageProfile/' + data
})
Vue.filter("URL2", (data) => {
  return USER_BACKEND_FOLDER + 'laboratoires/' + data
}) 
Vue.filter("URL3", (data) => {
  return URL_PUBLIC_FOLDER + 'laboratoire/rendez_vous/' + data
}) 
Vue.use(VueGoogleMaps, {
  load: {
    // v: '3.26',
    key: 'AIzaSyAh_o3rQILuAB7B_hiHxIdblSigSqsLO00',
    libraries: 'places,drawing,visualization',
  },
  draggable: true
  // installComponents: false,
})
var local = i18n.locale
window.moment = require('moment')
moment.locale(local)
var langs
Object.keys(i18n.messages).filter((e, i) => {
  if (e == local) {
    langs = Object.values(i18n.messages)[i].lang
  }
})
Vue.filter("moment", (data) => {
  return moment(data).fromNow()
}) 
Vue.use(VEditor, {
  
  name: 'v-editor-app', //Custom name
  config: {
    uploadImgUrl: '/api/upload', // upload api
    lang: langs

  }, //wagnEditor config
  uploadHandler: (type, resTxt) => { //Upload processing hook
    if (type === 'success') {
      var res = JSON.parse(resTxt) //Do not process the default look at the return value bit image path
      if (res.status !== 1) {
        return null
      }
      return res.data
    } else if (type === 'error') {
      //todo toast
    } else if (type === 'timeout') {
      //todo toast
    }
    return 'upload failed__'
  }
})
window.toastr = require("toastr")
toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: "toast-bottom-right",
  preventDuplicates: false,
  onclick: null, 
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",

  
  hideMethod: "fadeOut"
}
Vue.prototype.$http = axios
const token = store.state.access_token_vip ? store.state.access_token_vip : localStorage.getItem('AZDFDdsSDSJ21SSDO')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
Vue.config.productionTip = false
Vue.use(func)
Vue.use(VueI18n)
Vue.use(VueAxios, axios)
Vue.use(FlagIcon);
window.Fire = new Vue
window.axios = Vue.axios
Vue.component('vue-draggable-resizable', VueDraggableResizable)
 
Vue.axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "Authorization": `Bearer ${token}`
}



Vue.use(MultiFiltersPlugin)
const one = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')
 